export const initEmptyBlockData = {
  title: "",
  content1: "",
  content2: "",
  content3: "",
  content4: "",
  image: {
    src: "",
    alt: "",
    link: "",
  },
  link: "",
  showMore: {
    link: "/",
    text: "Show more",
  },
};

export const initBlockData = {
  ...initEmptyBlockData,
};
